import { SettingsEnumLikeKeys, SettingValue } from '../../../../../../services/settings-service';
import { DropdownList, DropdownListWithValueField } from '../../../../../components/inputs/DropdownListWithValueField';
import MarkerText from '../../../../../components/inputs/MarkerText';
import { useSettingDropdownValue } from '../../../../home/hooks/settings';
import { useSearchContext } from '../../../context/SettingsSearchContext';

export function SettingsDropdownElement<K extends SettingsEnumLikeKeys>(props: {
    id?: string;
    name: string;
    hint?: string;
    settingKey: K;
    options: DropdownList<SettingValue<K>>;
}) {
    const value = useSettingDropdownValue(props.options, props.settingKey);
    const context = useSearchContext();
    return (
        <div className="d-flex justify-content-between align-items-center px-3" id={props.id}>
            <div>
                <MarkerText highlight={context.term}>{props.name}</MarkerText>
                <div>
                    <MarkerText highlight={context.term} className="secondary-text">
                        {props.hint}
                    </MarkerText>
                </div>
            </div>
            <div className="flex-shrink-0 flex-grow-0 d-flex flex-column justify-content-center" style={{ width: 300, minHeight: 55 }}>
                <DropdownListWithValueField {...value} />
            </div>
        </div>
    );
}
